/*
 * Copyright 2025 coze-dev Authors
 * Modifications Copyright 2026 Bytefinger Technology (HK) Co., Limited (https://bytefinger.ai)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// @ts-ignore - brand config may not have types in all environments
import { brandConfig } from 'brand-config';
import FaviconBase from './favicon-base.png';
import FaviconAddon from './favicon-addon.png';
import { useSystemConfig } from '@adp-foundation/global-store';

export const Favicon = () => {
  const { brandConfiguration } = useSystemConfig();
  
  // Use brand config if available, otherwise fallback to local imports
  const baseIcon = brandConfig?.logos?.faviconBase || FaviconBase;
  const addonIcon = brandConfig?.logos?.faviconAddon || FaviconAddon;
  
  if (brandConfiguration?.logo_url) {
    return (
      <div className="relative flex items-center justify-center h-[100px]">
        <img
          src={brandConfiguration.logo_url}
          className="h-[100px] object-contain rounded-[21px]"
        />
      </div>
    );
  }

  return (
    <div className="relative flex items-center w-[160px] h-[100px]">
      <img
        src={baseIcon}
        className="w-[100px] h-[100px] rounded-[21px] border border-solid coz-stroke-plus"
      />
      <img
        src={addonIcon}
        className="absolute left-1/2 translate-x-[34px] top-[40px] w-[51px]"
      />
    </div>
  );
};
